import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { COMPANY_ADDRESS, COMPANY_PHONES, COMPANY_EMAIL } from '../config';
import CopyPhoneText from '../components/CopyPhoneText';
import {
    FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaUser, FaIdCard,
    // FaTelegram, FaViber, FaWhatsapp,
} from 'react-icons/fa';
import '../css/ContactsPage.css';

/* const messengers = [
    { icon: <FaTelegram />, label: 'Telegram', href: `https://t.me/${COMPANY_PHONES[2].number}`, display: COMPANY_PHONES[2].number },
    { icon: <FaViber />, label: 'Viber', href: `viber://chat?number=%2B${COMPANY_PHONES[2].number.slice(1)}`, display: COMPANY_PHONES[2].number },
    { icon: <FaWhatsapp />, label: 'WhatsApp', href: `https://wa.me/${COMPANY_PHONES[2].number.slice(1)}`, display: COMPANY_PHONES[2].number },
]; */

const ContactsPage = () => {
    return (
        <Layout>
            <SEO
                title="Контакти — Union Auto"
                description="Зв'яжіться з Union Auto: телефони та email. Доставка по всій Україні."
                canonical="/contacts"
            />
            <div className="contacts-page">

                <div className="contacts-hero">
                    <h1 className="contacts-hero__title">Контакти</h1>
                    <p className="contacts-hero__subtitle">
                        Ми завжди раді відповісти на ваші запитання. Оберіть зручний спосіб зв'язку.
                    </p>
                </div>

                <div className="contacts-grid">

                    {/* Телефони */}
                    <div className="contacts-card">
                        <h2 className="contacts-card__title">
                            <FaPhone className="contacts-card__icon contacts-card__icon--phone" />
                            Телефони
                        </h2>
                        <ul className="contacts-people">
                            {COMPANY_PHONES.map(({ number, display }) => (
                                <li key={number} className="contacts-people__item">
                                    <CopyPhoneText number={number} className="contacts-people__phone">
                                        {display}
                                    </CopyPhoneText>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Адреса та інтернет */}
                    <div className="contacts-card">
                        <h2 className="contacts-card__title">
                            <FaMapMarkerAlt className="contacts-card__icon contacts-card__icon--map" />
                            Адреса
                        </h2>
                        <div className="contacts-info-row">
                            <FaUser className="contacts-info-row__icon" />
                            <span>ФОП Фігура Тетяна Богданівна</span>
                        </div>
                        <div className="contacts-info-row">
                            <FaIdCard className="contacts-info-row__icon" />
                            <span>РНОКПП: 2586412525</span>
                        </div>
                        <div className="contacts-info-row">
                            <FaMapMarkerAlt className="contacts-info-row__icon" />
                            <span>{COMPANY_ADDRESS}</span>
                        </div>
                        <div className="contacts-info-row">
                            <FaIdCard className="contacts-info-row__icon" />
                            <span>Запис в ЄДР: 22.06.2023, №&nbsp;20041600000001010010</span>
                        </div>
                        <div className="contacts-info-row">
                            <FaEnvelope className="contacts-info-row__icon" />
                            <a href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a>
                        </div>
                        <div className="contacts-info-row">
                            <FaGlobe className="contacts-info-row__icon" />
                            <a href="https://union-auto.com.ua" target="_blank" rel="noopener noreferrer">
                                union-auto.com.ua
                            </a>
                        </div>
                    </div>

                    {/*
                    <div className="contacts-card contacts-card--messengers">
                        <h2 className="contacts-card__title">
                            <span className="contacts-card__icon contacts-card__icon--msg">💬</span>
                            Месенджери
                        </h2>
                        <div className="contacts-messengers">
                            {messengers.map(({ icon, label, href, display }) => (
                                <a key={label} href={href} className={`contacts-messenger contacts-messenger--${label.toLowerCase()}`}>
                                    <span className="contacts-messenger__icon">{icon}</span>
                                    <span className="contacts-messenger__label">{label}</span>
                                    <span className="contacts-messenger__number">{display}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                    */}

                </div>

                {/* Витяг з ЄДР */}
                <div className="contacts-edr">
                    <h2 className="contacts-edr__title">Витяг з ЄДР</h2>
                    <a href="/docs/edr1.png" target="_blank" rel="noopener noreferrer" className="contacts-edr__link">
                        <img src="/docs/edr1.png" alt="Витяг з Єдиного державного реєстру" className="contacts-edr__img" />
                    </a>
                </div>

            </div>
        </Layout>
    );
};

export default ContactsPage;
